// main-article-toc.js
// Builds the table of contents (desktop sidebar + mobile accordion), tracks the
// active section on scroll, and drives the reading-progress bar.
(function () {
  function slugify(text, usedSlugs) {
    var base = text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-');
    if (!base) base = 'section';
    var slug = base;
    var i = 2;
    while (usedSlugs[slug]) {
      slug = base + '-' + i;
      i += 1;
    }
    usedSlugs[slug] = true;
    return slug;
  }

  function init() {
    var content = document.getElementById('ArticleContent');
    var desktopList = document.getElementById('ArticleTOCListDesktop');
    var mobileList = document.getElementById('ArticleTOCListMobile');
    var progressBar = document.getElementById('ArticleProgressBar');

    if (!content) return;

    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3'));

    // Hide TOC entirely if the article has too few sections to be worth navigating.
    var desktopAside = document.getElementById('ArticleTOCDesktop');
    var mobileDetails = document.getElementById('ArticleTOCMobile');
    if (headings.length < 2) {
      if (desktopAside) desktopAside.style.display = 'none';
      if (mobileDetails) mobileDetails.style.display = 'none';
    } else {
      var usedSlugs = {};
      var links = [];

      headings.forEach(function (heading) {
        if (!heading.id) {
          heading.id = slugify(heading.textContent, usedSlugs);
        } else {
          usedSlugs[heading.id] = true;
        }

        var isSub = heading.tagName.toLowerCase() === 'h3';
        var linkHtml =
          '<a href="#' + heading.id + '" data-target="' + heading.id + '"' +
          (isSub ? ' style="padding-left:22px;font-size:1.3rem;"' : '') +
          '>' + heading.textContent + '</a>';

        if (desktopList) desktopList.insertAdjacentHTML('beforeend', linkHtml);
        if (mobileList) mobileList.insertAdjacentHTML('beforeend', linkHtml);
      });

      var allLinks = Array.prototype.slice.call(
        document.querySelectorAll('.article-toc__list a')
      );

      function setActive(id) {
        allLinks.forEach(function (link) {
          link.classList.toggle('is-active', link.getAttribute('data-target') === id);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                setActive(entry.target.id);
              }
            });
          },
          { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
        );
        headings.forEach(function (heading) {
          observer.observe(heading);
        });
      }

      // Close the mobile accordion after tapping a link.
      if (mobileDetails) {
        mobileList.addEventListener('click', function (event) {
          if (event.target.tagName === 'A') {
            mobileDetails.removeAttribute('open');
          }
        });
      }
    }

    // Reading progress bar, measured against the content column only.
    function updateProgress() {
      if (!progressBar) return;
      var rect = content.getBoundingClientRect();
      var total = content.offsetHeight - window.innerHeight;
      var scrolled = -rect.top;
      var pct = total > 0 ? Math.min(Math.max(scrolled / total, 0), 1) * 100 : 0;
      progressBar.style.width = pct + '%';
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
